import { render, staticRenderFns } from "./deleteResourceStoreSpecification.vue?vue&type=template&id=276e230c"
import script from "./deleteResourceStoreSpecification.vue?vue&type=script&lang=js"
export * from "./deleteResourceStoreSpecification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports